import { AxiosResponse } from "axios";

// Api's
import { api } from "./base/api";
import { IQuoteImageApi } from "./base";

// Models
import { Result } from "../models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

const baseRoute: string = "QuoteImage";

export class QuoteImageApi extends IQuoteImageApi {
	getDownloadImage(guidFile: string): Promise<AxiosResponse<Result<KeyValue>>> {
		return api.get(`${baseRoute}/downloadImage/${guidFile}`);
	}
}
